import { Guid } from '@web/utils';

export class AdminSubscriptionSubscriber {
  public constructor(
    private readonly data: {
      id: Guid;
      dignity: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get dignity(): string {
    return this.data.dignity;
  }
}
